define.alias("shared/modifiers/call-after-hover", "settings/modifiers/call-after-hover");